<span pTooltip="{{ ( 'tooltip.' + text) | translate}}" [tooltipPosition]="'bottom'" [tooltipStyleClass]="'tooltip-inner'">
	<fa-icon icon="info-circle" [size]="iconSize"></fa-icon>
</span>